import IntermediaryReducer from "@common/redux/reducers/IntermediaryReducer";
import BaseAction from "@common/redux/actions/BaseAction";

class IntermediaryAction extends BaseAction {
    open = async () => await this.dispatch({ open: true });

    close = this.reset;
}

const action = new IntermediaryAction(IntermediaryReducer);

export default action;
